export { default as useModeTheme } from 'components/switchTheme/hooks/useSwitchTheme/useSwitchTheme'
